import { StoreContext } from '@roc/feature-app-core';
import { useContext } from 'react';
import { StatusDashboardStore } from '../stores/statusDashboardStore';

export const useStatusDashboardStore = () => useContext<{
  statusDashboardStore: StatusDashboardStore
}>(StoreContext);
